import { FormChangeEvent } from '../../hooks/useFormValidation';
/**
 * Extracts the name of a form field from a given form event or object.
 *
 * This utility function is designed to handle two types of inputs:
 * 1. A `FormChangeEvent` object, which contains a `target` property.
 * 2. An object with `name` and `value` properties.
 *
 * @param formEvent - The form event or object to extract the field name from.
 *   - If it is a `FormChangeEvent`, the function will return the `name` property of the `target`.
 *   - If it is an object with a `name` property, the function will return the `name` value.
 *
 * @returns The name of the form field, or `undefined` if the name cannot be determined.
 */
export const checkFormEventFieldName = (formEvent: FormChangeEvent | string) => {
  if (
    typeof formEvent === 'object' &&
    typeof formEvent.target !== 'string' &&
    'target' in formEvent
  ) {
    return formEvent.target.name ? formEvent.target.name : undefined;
  } else if (typeof formEvent === 'string') return formEvent;
};
